import { Feature, Geometry } from 'geojson';

export enum MapType {
  WithSelection,
  WithDevices,
}

export type ReturnType = {
  type: 'FeatureCollection';
  features: Feature<Geometry>[];
};
